export default __webpack_public_path__ + "static/media/framed.48a6f6a3.svg";